import Link from "@amzn/awsui-components-react/polaris/link";
import { APFP_FINANCE_APPROVAL_GUIDE_LINK } from "shared/util/constants/constantValues";
import React from "react";

export const apidBanner = (setNotificationsItems) => {
  return {
    type: "info",
    content: (
      <React.Fragment>
        Starting April 1 2026, all APFP cash fund requests will require an
        Amazon Payee Central Account Profile ID (APID) at the time of
        submission. Please ensure your APID is ready before submitting new
        requests. Review{" "}
        <Link
          href={APFP_FINANCE_APPROVAL_GUIDE_LINK}
          color="inverted"
          target="_blank"
          rel="noopener noreferrer"
        >
          APFP Finance Approval guide
        </Link>{" "}
        for step-by-step instructions.
      </React.Fragment>
    ),
    dismissible: true,
    dimissLabel: "Dismiss message",
    onDismiss: () => setNotificationsItems([]),
    id: "apid_banner",
  };
};
